export default __webpack_public_path__ + "static/media/dash-job-inventory.05272d10.svg";